/*eslint-disable*/
import React, { Suspense, useState, Fragment } from "react";
import { useHistory } from 'react-router-dom';
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { green } from '@material-ui/core/colors';
import { styled } from "@material-ui/styles";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
import Button from "components/CustomButtons/Button.js";
import Check from "@material-ui/icons/Check";
import { FcCheckmark } from "react-icons/fc";
import { connect } from 'react-redux';
import {
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableFooter,
    TableSortLabel,
    TableContainer,
    TextField,
    Box,
    Stepper,
    Step,
    StepLabel,
    Checkbox,
    FormControlLabel,
    List,
    ListItem,
    Icon
} from "@material-ui/core";

import { Redirect } from "react-router-dom"; //import Redirect first

//views
import HeaderSection from "trade-customer-portal/views/header.js";
import FooterSection from "trade-customer-portal/views/footer.js"

// styling 
import tableStyle from "assets/jss/material-kit-pro-react/components/tableStyle.js";
import orderStyle from "assets/jss/CustomerTradePortal/views/OrderProcessPageSections/orderPorcessStageTwoPageStyle";
import modStyle from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

import OrderPriceBreakdown from "../StageTwo/Classes/OrderPriceBreakDown.js";
import OrderProductList from "../StageTwo/Classes/OrderSelectedProductList.js";
import NextBackButtons from "../StageTwo/Classes/StageTwoNextBackButtons.js";

const usemodalStyle = makeStyles(modStyle);
const useTableStyle = makeStyles(tableStyle);
const useStyles = makeStyles(orderStyle);


import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";

import LoadingData from '../../../../views/lottieLoading.js';
import { FaUserSecret } from "react-icons/fa";


import StepperView from '../../../Common/stepperPage.js';


// Landing Page for customer trade portal 
export default function OrderPorcessStageTwoPage() {

    const [count, setCount] = useState(0);

    const [data, setData] = useState();

    let productchecks = useSelector(state => state.orderReducer.orderSummaryProducts);
    let summaryCheck = useSelector(state => state.orderReducer.orderSummaryResult);

    let forceUserBack = useSelector(state => state.orderReducer.forceUserBack);

    let errorOccurredSummaryPage = useSelector(state => state.orderReducer.errorOccurredSummaryPage);

    const orderProcessSteps = useSelector(state => state.userReducer.orderProcessSteps)

    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

    });


    const classes = useStyles();


    if (!isEmpty(summaryCheck)) {
        return (
            <div >
                <HeaderSection />

                {/* <Parallax
                    image={require("assets/img/cadebyDepot.jpg")}
                    filter="dark"
                    xsmall
                > */}
                <div className={classNames(classes.main, classes.mainRaised, classes.mainSection, classes.sidePageMainSection)}>
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem
                                md={7}
                                sm={8}
                                className={classNames(
                                    classes.mlAuto,
                                    classes.mrAuto,
                                    classes.textCenter
                                )}
                            >
                                <h1 className={classes.title} style={{ color: "black" }}>Process New Order</h1>
                            </GridItem>
                            <GridItem md={7} sm={8} className={classNames(classes.mlAuto, classes.mrAuto)}>
                                <div className={classes.sidePageBorderLine} />
                            </GridItem>
                        </GridContainer>
                        
                        <div style={{
                            paddingBottom: "40px",
                            paddingTop: "10px",
                        }}>
                            <StepperView stepValue={1} />

                            <Fragment>
                                <OrderPriceBreakdown />
                                <OrderProductList />
                                <NextBackButtons />
                            </Fragment>
                        </div>
                        <br />
                    </div>
                </div>
                {/* </Parallax> */}


                {/* <div className={classNames(classes.main, classes.mainRaised)} >
                    <div className={classes.container} >

                        <div style={{
                            paddingBottom: "40px",
                            paddingTop: "10px",
                        }}>
                            <StepperView stepValue={1} />

                            <Fragment>
                                <OrderPriceBreakdown />
                                <OrderProductList />
                                <NextBackButtons />
                            </Fragment>
                        </div>
                    </div>
                </div> */}
                <FooterSection />

            </div>


        );
    }
    else {

        if (forceUserBack === true) {
            return <Redirect to="/OrderForm" />
        }
        else {

            if (errorOccurredSummaryPage) {
                return <Redirect to="/error-page" />
            }
            else {
                return (<LoadingData text={"Fetching Data, Please Wait..."} />)
            }
            
        }
    }
}










